import React from 'react';
import Image1 from "../../assets/ReceivePayments/Image1.png"
import Image2 from "../../assets/ReceivePayments/Image2.png"
import Image3 from "../../assets/ReceivePayments/Image3.png"
export default function ReceivePayments() {
  return (
    <div className="container">

<div className="py-5 bg-white">
  <div className="container">
    <div className="row align-items-center">
      {/* Left Side: Image */}
      <div className="col-md-6 text-center mb-4 mb-md-0">
        <img
          src={Image1}
          alt="Stripe payment system"
          className="img-fluid rounded"
        />
      </div>

      {/* Right Side: Text */}
      <div className="col-md-6">
        <h2>How Payments Work with Stripe</h2>
        <p>
          Membotic uses <strong>Stripe</strong> to securely handle all payments. Stripe is a trusted global platform used by businesses of all sizes to process online transactions.
        </p>
        <p>
          When you create a club on Membotic, a Stripe account is automatically created for you as part of the setup process. This account is linked to your club and used to receive payments from members.
        </p>
        <p>
          As members subscribe or pay for classes, their payments go through Stripe and are deposited directly into your Stripe account. Membotic automatically deducts its fee before the funds reach you.
        </p>
        <p>
          <strong>No manual setup, no chasing payments — everything just works.</strong>
        </p>
      </div>
    </div>
  </div>
</div>


<div className="py-5 bg-light">
  <div className="container">
    <div className="row align-items-center">
      {/* Left Side: Image */}
      <div className="col-md-6 text-center mb-4 mb-md-0">
        <img
          src={Image2}
          alt="Payment flow with Stripe"
          className="img-fluid rounded"
        />
      </div>

      {/* Right Side: Text */}
      <div className="col-md-6">
        <h2>Payment Flow on Membotic</h2>
        <p>
          The payment process on Membotic is straightforward and automated, powered by <strong>Stripe</strong>.
        </p>
        <p>
          When a customer books a class or subscribes:
        </p>
        <ul className="list-unstyled ps-3 mb-3">
          <li>• The customer pays using their card through Membotic.</li>
          <li>• Stripe securely processes the payment.</li>
          <li>• The funds are sent directly to your linked Stripe account.</li>
        </ul>
        <p>
          Stripe then transfers the payout to your bank account on a rolling schedule, typically every 7 days.
        </p>
        <p>
          <strong>There are no platform fees from Membotic — only Stripe’s standard rates apply.</strong>
        </p>
        <p>
          For detailed information on Stripe's fees, please visit their <a href="https://stripe.com/pricing" target="_blank" rel="noopener noreferrer">pricing page</a>.
        </p>
      </div>
    </div>
  </div>
</div>
<div className="py-5 bg-white">
  <div className="container">
    <div className="row align-items-center">
      {/* Left Side: Image */}
      <div className="col-md-6 text-center mb-4 mb-md-0">
        <img
          src={Image3}
          alt="Customer booking a class"
          className="img-fluid rounded"
        />
      </div>

      {/* Right Side: Text */}
      <div className="col-md-6">
        <h2>What Do Customers Pay For?</h2>
        <p>
          Membotic gives customers flexible ways to pay for access to a club or facility. Everything is handled online and is linked directly to your club’s offerings.
        </p>
        <p>
          Depending on how you've set up your club, customers can choose from:
        </p>
        <ul className="list-unstyled ps-3 mb-3">
          <li>• <strong>Subscriptions</strong> – recurring payments for ongoing access to your club or certain classes.</li>
          <li>• <strong>Flexible Class Passes</strong> – prepaid access to a set number of classes that customers can use when it suits them.</li>
          <li>• <strong>One-Off Bookings</strong> – pay-as-you-go access for individual sessions.</li>
        </ul>
        <p>
          Everything is managed through Membotic, so customers can browse, book, and pay in just a few taps.
        </p>
        <p>
          <strong>You control what’s offered. They choose how to pay.</strong>
        </p>
      </div>
    </div>
  </div>
</div>

<div className="py-4 bg-white text-center">
  <p className="mb-0">
    Questions? Contact us at <a href="mailto:info@membotic.com">info@membotic.com</a>
  </p>
</div>


    </div>
  );
}
